import { NgModule } from "@angular/core";
import { PaymentOptionsStateService } from "@modules/+new/payments/features/payment-options/domain/+state/payment-options.state.service";
import { PaymentOptionsRemote } from "@modules/+new/payments/features/payment-options/infrastructure/payment-options.remote";
import { FiatProviderDetailsAdapter } from "@modules/+new/payments/features/payment-options/domain/entities/fiat-provider-details.model";
import { BestFacade } from "@modules/new_account/features/my-best/domain/+state/best.facade";

@NgModule({
	providers: [PaymentOptionsRemote, PaymentOptionsStateService, FiatProviderDetailsAdapter, BestFacade]
})
export class PaymentOptionsModule {}
